export const IconArray = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M16 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 19q0-.424.287-.712A.97.97 0 0 1 16 18h2V6h-2a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 5q0-.424.287-.713A.97.97 0 0 1 16 4h2q.824 0 1.413.588Q20 5.175 20 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 18 20zM6 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18V6q0-.824.588-1.412A1.93 1.93 0 0 1 6 4h2q.424 0 .713.287Q9 4.576 9 5q0 .424-.287.713A.97.97 0 0 1 8 6H6v12h2q.424 0 .713.288Q9 18.575 9 19q0 .424-.287.712A.97.97 0 0 1 8 20z" />
    </svg>
  );
};
